import { Card, CardBody, Col, Form, Row } from "reactstrap";
import { CardNumber, CreditCards, FirstName, NameOnCard } from "../../../../constants";
import { dynamicImage } from "../../../../utils";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { CreditSelect } from "../../../../data/applications/ECommerce";
import FormInput from "./common/FormInput";
import SelectInput from "./common/SelectInput";
import { Image } from "../../../../coreComponents/Image";

// This component is used to create a credit card form with fields for card details and an image preview.
const CreditCard = () => {
  return (
    <Col xxl="8" className="box-col-12">
      <Card>
        <CommonCardHeader title={CreditCards} headClass="pb-0" />
        <CardBody>
          <Row>
            <Col md="7" className="order-md-0 order-1">
              <Form className="theme-form mega-form">
                <FormInput type="text" placeholder={CardNumber} />
                <FormInput type="text" placeholder={FirstName} />
                <FormInput type="date" />
                <FormInput type="text" placeholder={NameOnCard} />
                <SelectInput data={CreditSelect} size={1} />
              </Form>
            </Col>
            <Col md="5" className="text-center">
              <Image className="img-fluid" src={dynamicImage(`ecommerce/card.png`)} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CreditCard;
